/** Entry-state key the mail view persists its inbox filter under. */
export const INBOX_FILTER_ENTRY_KEY = 'soup.inboxFilter';
